// src/utils/guest.js

export function getGuestId() {
    let guestId = localStorage.getItem("guest_id");
  
    if (!guestId) {
      guestId = crypto.randomUUID(); // Tạo UUID v4
      localStorage.setItem("guest_id", guestId);
    }
  
    return guestId;
  }
  
  export function clearGuestId() {
    localStorage.removeItem("guest_id");
  }
  